import styled from "styled-components";

import { colors, radii } from "shared/ui";

export const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

/*
* Одна разметка на оба вьюпорта: на узком строка раскладывается в блок, кнопки
* уезжают под текст. MUI Table не используем — она не ужимается на мобиле.
* */
export const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px;
    border: 1px solid ${colors.borderSoft};
    border-radius: ${radii.base};
    background: ${colors.surface};
    cursor: pointer;

    @media (max-width: 700px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

export const Name = styled.div`
    font-size: 16px;
    font-weight: 700;
    overflow-wrap: break-word;
`;

export const Meta = styled.div`
    color: ${colors.textSecondary};
    font-size: 13px;
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    flex-wrap: wrap;
`;
